// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"k7-z"};